import { createFileRoute } from '@tanstack/react-router';
import { requireCapability } from '@/lib/route-guards';
import { useSetViewShim } from '@/lib/use-set-view';
import { LogsView } from '@/screens/admin-logs';
import { parseAdminLogSearch } from '@/lib/admin-log-search';
import { warmBackground } from '@/api/loaders';
import { copilotStatus } from '@/api/resources';

export const Route = createFileRoute('/admin/logs')({
  // The server requires `LogsView: full` (the API's admin.rs), so a
  // session-only guard let a planner land on a screen that could only ever be
  // empty. `requireCapability`, not `requireGlobalCapability` — the latter also
  // rejects production-scoped users, which is stricter than the server.
  beforeLoad: requireCapability('logs_view', 'full'),
  validateSearch: parseAdminLogSearch,
  // Log tail, stats, groups, and archive reads remain volatile. The Copilot
  // feature gate is configuration-backed, so intent navigation warms it.
  loader: ({ context }) => {
    warmBackground(context.queryClient, copilotStatus(undefined));
  },
  component: Page,
});

function Page() {
  const setView = useSetViewShim();
  const search = Route.useSearch();
  return (
    <LogsView
      setView={setView}
      initialSignature={search.signature}
      initialTrace={search.trace_id}
      initialComponent={search.component}
      initialWindow={search.window}
    />
  );
}
